module.exports = {
	css: {
		loaderOptions: {
			sass: {
			data:  `
				@import "./src/styles/_variables.scss";
				@import "./src/styles/_reset.scss";
				@import "./src/styles/_typography.scss";
				@import "./src/styles/_mixins.scss";
				@import "./src/styles/_modals.scss";
				`
			}
		}
	},
	devServer: {
		disableHostCheck: true,
		port: 8081,
		// public: '0.0.0.0:8081'


		
		// port: 8081,
		// host: '192.168.0.141'

		// port: 8088,
		// host: '0.0.0.0',
		// https: true,
		// hotOnly: false
	},
	publicPath: process.env.NODE_ENV === 'production' ? '/' : '/'
};